import type {
  IReceipt,
  BankDetails,
  BankDetailsBase,
  BeneficiaryInfo,
} from 'src/shared/types/bank';

import { getApiUrl } from 'src/shared/utils/get-api-url';

import { baseApi } from '../base-api';
import { createFormData } from '../utils/create-form-data';

import type {
  IAddBankDetailsRequest,
  IRegisterSignMeRequest,
  CheckSignStatusResponse,
} from './types';

const api = baseApi.extend({
  prefixUrl: `${getApiUrl(3)}/PaymentForwarder/`,
});

export const apiPaymentForwarder = {
  createBeneficiary: async () => await api.post(`create-beneficiary`, { json: {} }).json(),
  addBankDetails: async (data: IAddBankDetailsRequest) =>
    await api.post(`add-bank-details`, { json: data }).json(),
  getBankDetails: async () => await api.get<BankDetailsBase[]>(`bank-details`).json(),
  getBankDetailsById: async (id: string) =>
    await api.get<BankDetails>(`beneficiaries/bank-details/${id}`).json(),
  getBankDetailsByIds: async (ids: string[]) => {
    const promises = ids.map((id) =>
      api.get<BankDetails>(`beneficiaries/bank-details/${id}`).json()
    );

    return await Promise.all(promises);
  },
  getBeneficiaryInfo: async () => await api.get<BeneficiaryInfo>(`Get`).json(),
  getActFile: async (id: number) => await api.get(`agent/${id}/pdf`).blob(),
  getUnsignedDocuments: async () => await api.get<number>(`unsigned-documents`).json(),
  getUnsignedReceipts: async () => await api.get<number>(`unsigned-receipts`).json(),
  getReceipts: async () => await api.get<IReceipt[]>(`receipts`).json(),
  getReceipt: async (id: number) => await api.get<IReceipt>(`receipts/${id}`).json(),
  attachSignedDocument: async (actId: string, file: File) => {
    const formData = createFormData({ file, invoiceDocumentId: actId });

    return await api
      .post(`attach-signed-document`, {
        body: formData,
      })
      .json();
  },
  attachReceipt: async (actId: number, link: string, file: File) => {
    const formData = createFormData({ invoiceDocumentId: actId, link, file }, 'file');

    return await api
      .post(`attach-receipt`, {
        body: formData,
      })
      .json();
  },
  registerSignMe: async (data: IRegisterSignMeRequest) =>
    await api.post(`sign-me-reg`, { json: data }).json(),
  startSign: async (actId: number, isApproved: boolean, rejectReason?: string) =>
    await api
      .post(`${actId}/sign/blogger`, {
        json: {
          isApproved,
          reason: rejectReason,
          method: 0,
        },
      })
      .json(),
  checkSignStatus: async (actId: number) =>
    await api.get<CheckSignStatusResponse>(`${actId}/check/blogger`).json(),
};
